import { render, staticRenderFns } from "./PostingRules.vue?vue&type=template&id=58652077&"
import script from "./PostingRules.vue?vue&type=script&lang=js&"
export * from "./PostingRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports